import { observable, action } from 'mobx';
import { FurtherConsiderations } from '../models';
import { FurtherConsiderationsStore } from './further-considerations-store';
import { LoadingStore } from './loading-store';

export class FurtherConsiderationsEntryStore {
  @observable furtherConsiderations: FurtherConsiderations = new FurtherConsiderations();

  constructor(private furtherConsiderationsStore: FurtherConsiderationsStore, private loadingStore: LoadingStore) {
  }

  @action loadFurtherConsiderations(): Promise<FurtherConsiderations> {
    this.loadingStore.appIsBusy();
    return this.furtherConsiderationsStore.loadFurtherConsiderations().then((furtherConsiderations) => {
      this.furtherConsiderations = furtherConsiderations;
      console.log(furtherConsiderations);
      this.loadingStore.appIsNotBusy();
      return this.furtherConsiderations;
    }, (error: any) => {
      console.error(error);
      this.loadingStore.appIsNotBusy();
      // TODO: Determine the best way to handle errors
      return new FurtherConsiderations();
    });
  }
}